module.exports = __webpack_public_path__ + "static/img/MATTHEW-BECKER.1ea432d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MATTHEW-BECKER.jpg
// module id = Sh2O
// module chunks = 0